import { BaseService } from './base-service';

export class SettingsService extends BaseService {
  baseURL = 'Settings';
}
